import { Injectable } from '@angular/core';

import { toFixed } from '../../../core/services/utils/numbers';
import { AtividadeSearchTotal } from '../atividade-search';

@Injectable({
    providedIn: 'root'
})
export class AtividadeCalculoService {

    /** Calcula a quantidade total de atividades */
    calcularQuantidadeAtividadesTotal(totais: AtividadeSearchTotal[]): number {
        let quantidadeAtividadesTotal = 0;
        totais?.forEach(total => {
            quantidadeAtividadesTotal += total.quantidadeAtividades ? Number(total.quantidadeAtividades) : 0;
        })

        return toFixed(quantidadeAtividadesTotal, 0)
    }

    /** Calcula o percentual de participação da quantidade de atividades */
    calcularPercParticipacaoQuantidadeAtividades(quantidadeAtividades: number, quantidadeAtividadesTotal: number): number {
        quantidadeAtividades = quantidadeAtividades && !isNaN(quantidadeAtividades) ? Number(quantidadeAtividades) : 0;
        quantidadeAtividadesTotal = quantidadeAtividadesTotal && !isNaN(quantidadeAtividadesTotal) ? Number(quantidadeAtividadesTotal) : 0;

        if (quantidadeAtividadesTotal <= 0) {
            return 0;
        }

        const perc = (quantidadeAtividades / quantidadeAtividadesTotal) * 100;
        return toFixed(perc, 2);
    }
}
